/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PublicDeparturePolymorphicTypes } from './publicDeparturePolymorphicTypes';

export interface PublicDeparture {
    readonly id?: string;
    readonly code?: string;
    title: string;
    additional_text?: string | null;
    start_date: string;
    end_date: string;
    readonly price?: string;
    readonly price_currency?: string;
    readonly deposit?: string;
    readonly single_supplement?: string;
    status?: PublicDeparture.StatusEnum;
    readonly available_spots?: number;
    readonly itinerary?: string;
    readonly itinerary_id?: string;
    readonly self_booking_enabled?: boolean;
    readonly trip_id?: string;
    readonly display_status?: PublicDeparture.DisplayStatusEnum;
    resourcetype?: PublicDeparturePolymorphicTypes;
}
export namespace PublicDeparture {
    export type StatusEnum =
        | 'SCHEDULED'
        | 'GUARANTEED'
        | 'SOLD_OUT'
        | 'CANCELLED'
        | 'RUNNING'
        | 'COMPLETED';
    export const StatusEnum = {
        Scheduled: 'SCHEDULED' as StatusEnum,
        Guaranteed: 'GUARANTEED' as StatusEnum,
        SoldOut: 'SOLD_OUT' as StatusEnum,
        Cancelled: 'CANCELLED' as StatusEnum,
        Running: 'RUNNING' as StatusEnum,
        Completed: 'COMPLETED' as StatusEnum,
    };
    export type DisplayStatusEnum = 'OPEN' | 'FEW_SPOTS' | 'SOLD_OUT';
    export const DisplayStatusEnum = {
        Open: 'OPEN' as DisplayStatusEnum,
        FewSpots: 'FEW_SPOTS' as DisplayStatusEnum,
        SoldOut: 'SOLD_OUT' as DisplayStatusEnum,
    };
}
